import React from 'react'
import PropTypes from 'prop-types'
import { FixedSizeList as List } from 'react-window'

const PADDING_TOP = 8
const ITEM_HEIGHT = 38
const VISIBLE_COUNT = 8

function renderRow(props) {
  const { data, index, style } = props
  return React.cloneElement(data[index], {
    style: {
      ...style,
      top: style.top + PADDING_TOP,
    },
  })
}

const OuterElementContext = React.createContext({})

const OuterElementType = React.forwardRef((props, ref) => {
  const outerProps = React.useContext(OuterElementContext)
  return <div ref={ref} {...props} {...outerProps} />
})

const VirtualList = React.forwardRef(({ children, ...other }, ref) => {
  const itemData = React.Children.toArray(children)
  const itemCount = itemData.length

  return (
    <div ref={ref}>
      <OuterElementContext.Provider value={other}>
        <List
          itemData={itemData}
          itemCount={itemCount}
          height={VISIBLE_COUNT * ITEM_HEIGHT + PADDING_TOP}
          width="100%"
          outerElementType={OuterElementType}
          innerElementType="ul"
          itemSize={ITEM_HEIGHT}
          overscanCount={5}
        >
          {renderRow}
        </List>
      </OuterElementContext.Provider>
    </div>
  )
})

VirtualList.defaultProps = {
  children: null,
}

VirtualList.propTypes = {
  children: PropTypes.node,
}

export default VirtualList
